import React from 'react';
import { LoadingScreen } from './LoadingScreen';
import { LoadingSkeleton } from './LoadingSkeleton';
import { getLoadingMessage } from '../../../data/loadingMessages';

/**
 * Loading (Unified)
 * - type: 'screen' | 'skeleton'
 * - screen: centralized message via messageKey
 * - skeleton: placeholder layout options
 */
export const Loading = ({
  // Common
  type = 'screen',            // 'screen' | 'skeleton'
  // Screen message lookup
  messageKey,                 // string (key for loading message)
  fallback,                   // string (fallback message if key not found)
  // LoadingScreen props
  variant = 'default',        // 'default' | 'minimal' | etc.
  size = 'full',              // 'full' | 'compact' | etc.
  showProgress = false,       // boolean (show progress bar)
  progress = 0,               // number (progress value)
  // Skeleton props
  lines = 3,                  // number (lines of skeleton)
  showAvatar = false,         // boolean (show avatar placeholder)
  showImage = false,          // boolean (show image placeholder)
  className = '',             // string (additional class names)
}) => {
  if (type === 'skeleton') {
    return (
      <LoadingSkeleton
        lines={lines}
        showAvatar={showAvatar}
        showImage={showImage}
        className={className}
      />
    );
  }

  const message = getLoadingMessage(messageKey, fallback);
  return (
    <LoadingScreen
      variant={variant}
      size={size}
      showProgress={showProgress}
      progress={progress}
      message={message}
    />
  );
};

 
